export default __webpack_public_path__ + "static/media/Tutorial4Mobile.50e2bd8e.png";